import { render } from "./Lobby.vue?vue&type=template&id=243ad39d&scoped=true&ts=true"
import script from "./Lobby.vue?vue&type=script&lang=ts"
export * from "./Lobby.vue?vue&type=script&lang=ts"

import "./Lobby.vue?vue&type=style&index=0&id=243ad39d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243ad39d"]])

export default __exports__